import React, { useEffect } from 'react';

import DialogLoader from '../../../../components/transitions/DialogLoader/DialogLoader';
import { useAuthorize } from '../hooks/useAuthorize';
import { ComponentsWrapper } from '../layout/layout';

export const Authorize = ({ isTokenExpired = false }: { isTokenExpired?: boolean }) => {
  const { getAuthorizeUrl } = useAuthorize();

  useEffect(() => {
    const authorizeURL = getAuthorizeUrl(isTokenExpired) ?? undefined;

    if (authorizeURL) {
      window?.location?.replace(authorizeURL);
    }
  }, [getAuthorizeUrl, isTokenExpired]);

  return (
    <ComponentsWrapper>
      <DialogLoader />
    </ComponentsWrapper>
  );
};
